/* @flow */
import BoxBody from 'components/BoxBody.jsx';
import Button from 'components/Button.jsx';
import Dialog from 'components/Dialog.jsx';
import LinkConstants from 'constants/LinkConstants';
import MailTo from 'components/MailTo.jsx';
import PaymentAccountActions from 'payments/actions/PaymentAccountActions';
import React, { Component } from 'react';
import TitleHeader from 'components/TitleHeader.jsx';

import styles from './styles/AccountTransferDisabledModal.css';

const SupportMailTo = () =>
  <MailTo to={LinkConstants.SUPPORT_EMAIL}>
    {LinkConstants.SUPPORT_EMAIL}
  </MailTo>;

class AccountTransferDisabledModal extends Component {
  componentDidMount() {
    // noop, http error is normal here as this endpoint is ratelimited.
    PaymentAccountActions.requestVerificationHelp().then(() => {}, () => {});
  }

  getSubtext() {
    return (
      <span>
        The Support team will follow up with you shortly!
        If you have any questions, please contact{' '}
        <SupportMailTo />
      </span>
    );
  }

  render() {
    return (
      <Dialog
        eventScreenName="AccountTransferDisabledModal"
        {...this.props}
        size="small">
        <BoxBody>
          <TitleHeader
            image={require('assets/images/payments/money-transmission.svg')}
            imageClassName={styles.image}
            title="We need more information to verify your identity"
            subtext={this.getSubtext()}
          />
          <Button onClick={this.props.onRequestHide}>
            Done
          </Button>
        </BoxBody>
      </Dialog>
    );
  }
}

export default AccountTransferDisabledModal;



// WEBPACK FOOTER //
// ./src/payments/components/AccountTransferDisabledModal.jsx